import { getLocalStorage } from '../../tools/localStorageService';
import { NAME } from '../constants';
import { IAuthState } from '../types';

export const isLoggedIn = (authStorageName: string = NAME): boolean => {
  const storage = getLocalStorage<IAuthState>(authStorageName);
  return !!storage?.token ?? false;
};
